import { ControlValueAccessor, NgControl } from '@angular/forms'
import { ChangeDetectorRef, Directive, Input, inject } from '@angular/core'
import { SelectCode, SelectCodeValue, SelectImage, SelectPhone } from '@corporate-tailwind/model'

@Directive()
export abstract class CorpControlCommonComponent implements ControlValueAccessor {
  protected ngControl: NgControl | null = null
  protected cdr = inject(ChangeDetectorRef)

  @Input('corp-label') corpLabel: string | null = null
  @Input('corp-value') corpValue: string | number | SelectCode | SelectCodeValue | SelectImage | SelectPhone | null = null
  @Input('corp-icon') corpIcon: string | null = null
  @Input('corp-type') corpType: string = 'text'
  @Input('corp-suffix') corpSuffix: string | null = null;
  @Input('corp-prefix') corpPrefix: string | null = null;
  @Input('corp-loading') corpLoading: boolean = false
  @Input('corp-size') corpSize: 'xs' |'sm' | 'md' | 'lg' | 'xl' = 'sm'
 
  private _corpReadonly = false
  @Input('corp-readonly')
  set corpReadonly(value: any) { this._corpReadonly = value !== false && value != null }
  get corpReadonly(): boolean { return this._corpReadonly }

  private _corpImg = false
  @Input('corp-img')
  set corpImg(value: any) { this._corpImg = value !== false && value != null }
  get corpImg(): boolean { return this._corpImg }

  value: any = ''
  disabled = false
  isForm = true

  protected onChange: (value: any) => void = () => {}
  protected onTouched: () => void = () => {}

  protected setNgControl(ctrl: NgControl | null) {
    this.ngControl = ctrl
    if (ctrl) {
      ctrl.valueAccessor = this
    }
  }

  // ControlValueAccessor
  writeValue(value: any): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
    this.cdr.markForCheck()
  }

  protected onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value
    this.value = val
    this.onChange(val)
  }

  onBlur(event: Event): void {
    this.onTouched()
  }
}
